import script from "./ServicesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesView.vue?vue&type=script&setup=true&lang=js"

import "./ServicesView.vue?vue&type=style&index=0&id=28094ed3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28094ed3"]])

export default __exports__